var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnowflakeLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6225 17.6723C42.1629 17.6723 41.7608 17.5033 41.4161 17.1653C41.0715 16.8273 40.8991 16.433 40.8991 15.9823C40.8991 15.4941 41.0715 15.0904 41.4161 14.7712C41.7608 14.4519 42.1629 14.2923 42.6225 14.2923C43.1203 14.2923 43.532 14.4519 43.8575 14.7712C44.1831 15.0904 44.3458 15.4941 44.3458 15.9823C44.3458 16.433 44.1831 16.8273 43.8575 17.1653C43.532 17.5033 43.1203 17.6723 42.6225 17.6723ZM19.07 45.2757V36.375L12.5212 42.797L10.1085 40.431L19.07 31.643V27.249H14.5892L5.62778 36.037L3.21509 33.671L9.76384 27.249H0.6875V23.869H9.76384L3.21509 17.447L5.62778 15.081L14.5892 23.869H19.07V19.475L10.1085 10.687L12.5212 8.32098L19.07 14.743V5.84232H22.5167V14.743L29.0654 8.32098L31.4781 10.687L22.5167 19.475V23.869H40.8991V27.249H31.8228L38.3715 33.671L35.9588 36.037L26.9974 27.249H22.5167V31.643L31.4781 40.431L29.0654 42.797L22.5167 36.375V45.2757H19.07ZM40.8991 10.9123V0.208984H44.3458V10.9123H40.8991Z",
    fill: "#2B66C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflakeLightBlue);
export default __webpack_public_path__ + "static/media/snowflake-light-blue.80c382ef024bd842044c9cc3c6a1cd80.svg";
export { ForwardRef as ReactComponent };